import pushGTMEvent from '@helpers/analyticsHelpers/pushGTMEvent';

interface Props {
  deliveryStoreId: string;
  theme: string;
}
const trackPickUpInStoreSelection = ({ deliveryStoreId, theme }: Props) => {
  const isCheckout = theme === 'checkout';
  pushGTMEvent({
    event: 'Track',
    category: isCheckout ? 'checkout_delivery_options' : 'delivery_widget',
    action: isCheckout ? 'click_and_collect_confirmed' : 'click_and_collect',
    label: deliveryStoreId,
    value: 0,
  });
};

export default trackPickUpInStoreSelection;
